// extracted by mini-css-extract-plugin
export default {"createFromScratchReportModalContainer":"CreateFromScratchReportModal_createFromScratchReportModalContainer__wbVqw"};